import React from 'react';
import {QuickTip} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import EmployeeErrors from './EmployeeErrors';

const ErroredEmployeesWarning = ({erroredNmbrEmployees}) => {
  if (erroredNmbrEmployees.length === 0) return null;

  const paragraphs = [
    <FormattedMessage id='nmbr.errored_employees.The following employees errored when last updating their payroll information. Some pay rates or hours may be incorrect when running payroll:'/>,
    <div className='pl2'>
      {erroredNmbrEmployees.map(nmbrEmployee => <li key={nmbrEmployee.id} className='mb1'>
        <div>{nmbrEmployee.employee.name}</div>
        <div className='ml2 mb1'><EmployeeErrors nmbrEmployee={nmbrEmployee}/></div>
      </li>)}
    </div>
  ];

  return (
    <div className='mb2'>
      <QuickTip
        trait='error'
        header={<FormattedMessage id='nmbr.errored_employees.Errors Requiring Attention'/>}
        paragraphs={paragraphs}
      />
    </div>
  );
};

export default ErroredEmployeesWarning;
